// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".localize-debug-mode-target {\n  position: relative; }\n  .localize-debug-mode-target .localize-debug-mode-click-area {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 8px;\n    height: 8px;\n    background-color: green;\n    z-index: 1300; }\n", ""]);
// Exports
module.exports = exports;
